module.exports = __webpack_public_path__ + "media/images/down-carrot-b8686ac922f9a26c437a7ca597c6a181.svg";